import React from 'react'
import { Field, reduxForm } from 'redux-form'
import Captcha from '../../Captcha'
import { normalizeCnpj, normalizePhone, validarCNPJ } from '../../normalizes/Normalizes'

const validate = values => {
  const requiredMsg = "Este campo é obrigatório";
  const errors = {};
  const mimeList = [
    "image/gif", "image/png", "image/jpeg", "image/jpg", "image/bmp", "application/pdf"
  ];
  const mimeListCert = [
    "application/x-pem-file", "application/x-x509-ca-cert", "application/x-x509-user-cert", "application/x-pkcs7-crl"
  ];

  if (!values.nomeEntidade) {
    errors.nomeEntidade = requiredMsg
  }

  if (!values.cnpj) {
    errors.cnpj = requiredMsg
  } else if (!validarCNPJ(values.cnpj)) {
    errors.cnpj = "CNPJ não é válido"
  }

  if (!values.fileAtas) {
    errors.fileAtas = requiredMsg
  } else if (mimeList.indexOf(values.fileAtas.type) < 0) {
    errors.fileAtas = "Arquivo de formato inválido, apeas arquivos .pdf, .jpeg, .jpg, .png e .gif"
  }

  if (!values.fileEstatuto) {
    errors.fileEstatuto = requiredMsg
  } else if (mimeList.indexOf(values.fileEstatuto.type) < 0) {
    errors.fileEstatuto = "Arquivo de formato inválido, apeas arquivos .pdf, .jpeg, .jpg, .png e .gif"
  }

  if (!values.fileDocumentosResponsaveis) {
    errors.fileDocumentosResponsaveis = requiredMsg
  } else if (mimeList.indexOf(values.fileDocumentosResponsaveis.type) < 0) {
    errors.fileDocumentosResponsaveis = "Arquivo de formato inválido, apeas arquivos .pdf, .jpeg, .jpg, .png e .gif"
  }
  if (!values.fileCertificado) {
    errors.fileCertificado = requiredMsg
  } else if (mimeListCert.indexOf(values.fileCertificado.type) < 0) {
    errors.fileCertificado = "Arquivo de formato inválido, apeas arquivos .pem, .crt"
  }

  if (!values.nomeRepresentante) {
    errors.nomeRepresentante = requiredMsg
  }

  if (!values.emailRepresentante) {
    errors.emailRepresentante = requiredMsg
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.emailRepresentante)) {
    errors.emailRepresentante = 'Endereço de e-mail inválido'
  }

  if (!values.telefoneRepresentante) {
    errors.telefoneRepresentante = requiredMsg
  }

  if (!values.nomeOperacaoEntidade) {
    errors.nomeOperacaoEntidade = requiredMsg
  }

  if (!values.emailOperacaoEntidade) {
    errors.emailOperacaoEntidade = requiredMsg
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.emailOperacaoEntidade)) {
    errors.emailOperacaoEntidade = 'Endereço de e-mail inválido'
  }

  if (!values.captcharesponse){
    errors.captcharesponse = "Por favor, confirme o Captcha"
  }

  return errors
}

const renderField = ({
                       input,
                       label,
                       type,
                       meta: {touched, error, warning}
                     }) => (
  <div className='form-group'>
    <label className='mt-3' htmlFor={input.name}>{label}</label>
    <input {...input} id={input.name} placeholder={label} type={type}
           className={`form-control ${touched && ((error && 'is-invalid'))}`}
    />

    {touched && ((error && <span className='text-danger'>{error}</span>) || (warning &&
      <span className='text-warning'>{warning}</span>))}
  </div>
)

const renderChkBoxField = ({
                             input,
                             label,
                             text,
                             type,
                             meta: {touched, error, warning}
                           }) => (
  <div className='form-group'>
    <label className='mt-3'>{label}
      <input {...input} id={input.name} type={type} className={`${touched && ((error && 'is-invalid'))}`}/>
      {text}
    </label>

    {touched && ((error && <span className='text-danger'>{error}</span>) || (warning &&
      <span className='text-warning'>{warning}</span>))}
  </div>
)

const adaptFileEventToValue = delegate => (
  e => delegate(e.target.files[0])
)

const FileInput = ({
                     label,
                     input: {
                       value: omitValue,
                       onChange,
                       onBlur,
                       name,
                       ...inputProps,
                     },
                     meta: {touched, error, warning},
                     ...props,
                   }) => (
  <div>
    <label className='mt-3'>{label}</label>
    <input onChange={adaptFileEventToValue(onChange)} onBlur={adaptFileEventToValue(onBlur)}
           id={name} name={name} type="file" {...inputProps} {...props} className={`${touched && ((error && 'is-invalid'))}`}/>
    {touched && ((error && <span className='text-danger'>{error}</span>) || (warning &&
      <span className='text-warning'>{warning}</span>))}
  </div>
)

const FormEmissor = props => {
  const {handleSubmit, submitting} = props
  return (
    <form onSubmit={handleSubmit}>

      <div className="row">
        <div className="col-md-6">

          <Field name="nomeEntidade" type="text" component={renderField} label="Nome da entidade"/>

        </div>

        <div className="col-md-6">

          <Field name="cnpj" type="text" component={renderField} label="CNPJ" normalize={normalizeCnpj}/>

        </div>
      </div>

      <div className="row">
        <div className="col">

          <Field name="fileAtas" label="Cópia autenticada da Ata de Eleição e da Ata de Posse da diretoria em
              exercício, devidamente registrada em Cartório de Títulos e Documentos, com mandato
              vigente." component={FileInput}/>
          <small id="fileAtasDesc" className="form-text text-muted">
            Todos os documentos em apenas um arquivo .pdf, .jpeg, .jpg, .png e .gif.
          </small>

        </div>
      </div>

      <div className="row">
        <div className="col">

          <Field name="fileEstatuto" label="Cópia autenticada do Estatuto Social de entidade registrado em
              cartório." component={FileInput}/>
          <small id="fileEstatutoDesc" className="form-text text-muted">
            Todos os documentos em apenas um arquivo .pdf, .jpeg, .jpg, .png e .gif.
          </small>

        </div>
      </div>

      <div className="row">
        <div className="col">

          <Field name="fileDocumentosResponsaveis" label="Cópia autenticada dos documentos oficiais (RG ou CNH)
              e CPF dos responsáveis legais:" component={FileInput}/>
          <small id="fileDocumentosResponsaveisDesc" className="form-text text-muted">
            Todos os documentos em apenas um arquivo .pdf, .jpeg, .jpg, .png e .gif.
          </small>

        </div>
      </div>

      <div className="row">
        <div className="col">

          <Field name="fileCertificado" label="Certificado digital da entidade" component={FileInput}/>
          <small id="fileCertificadoDesc" className="form-text text-muted">
            Todos os documentos em apenas um arquivo .pem, .crt.
          </small>

        </div>
      </div>

      <div className="row">
        <div className="col-md-6">

          <Field name="nomeRepresentante" type="text" component={renderField} label="Nome completo do representante"/>

        </div>

        <div className="col-md-6">

          <Field name="emailRepresentante" type="text" component={renderField} label="Email do representante"/>

        </div>
      </div>

      <div className="row">
        <div className="col">

          <Field name="telefoneRepresentante" type="text" component={renderField} label="Telefone de Contato" normalize={normalizePhone}/>

        </div>
      </div>

      <div className="row">
        <div className="col-md-6">

          <Field name="nomeOperacaoEntidade" type="text" component={renderField} label="Nome do responsável pela operação"/>

        </div>

        <div className="col-md-6">

          <Field name="emailOperacaoEntidade" type="text" component={renderField}
                 label="E-mail do responsável pela operação"/>

        </div>
      </div>

      <div className="row">
        <div className="col">
          <p>
            O cadastramento não significa nem requer associação ou filiação de qualquer natureza às entidades
            estudantis nacionais, sendo necessário tão somente para fins de unificação do processo de validação dos certificados das CIEs.
          </p>
        </div>
      </div>

      <div className="row">
        <div className="col">

          <Field
            name='receberComunicados'
            type='checkbox'
            text='Concordo em receber as comunicações institucionais do MeiaEntrada, ciente de que meus dados não serão compartilhados.'
            component={renderChkBoxField}/>
        </div>
      </div>

      <div className="row">
        <div className="col text-center">
          <Field name='captcharesponse' component={Captcha}/>
        </div>
      </div>

      <div className="text-center">
        <button type="submit" disabled={submitting} className='btn btn-success'>
          Enviar
        </button>
      </div>

    </form>
  )
}

export default reduxForm({
  form: 'formEmissor', // a unique identifier for this form
  validate, // <--- validation function given to redux-form
  initialValues: {receberComunicados: true}
})(FormEmissor)



// WEBPACK FOOTER //
// ./src/components/views/BancoDeDadosNacional/FormEmissor.js